





import {Component, Vue} from 'vue-property-decorator'
import InputSelect from '@/components/lib/InputSelect.vue'
import {IOption} from '@/components/lib/models'
import cookie from '@/cookie'

@Component({
  components: {
    InputSelect
  }
})
export default class LocaleChanger extends Vue {

  get locales(): IOption<string>[] {
    return Object.entries(this.$i18n.messages).map(locale => locale[0]).map(locale => ({
      name: locale.toUpperCase(),
      value: locale
    }))
  }

  get locale(): string {
    return this.$i18n.locale;
  }
  set locale(value: string) {
    cookie.set('TRA-lang', value);
    this.$i18n.locale = value;
  }

}
